export default __webpack_public_path__ + "static/media/passchng.1c544307.gif";